var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Button',{attrs:{"empty":_vm.empty},on:{"click":function($event){$event.preventDefault();return _vm.onDTCreateClick.apply(null, arguments)}}},[[_vm._v(" Create a new Day Template ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }